import script from "./UserPersonalInfos.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPersonalInfos.vue?vue&type=script&lang=ts&setup=true"

import "./UserPersonalInfos.vue?vue&type=style&index=0&id=3d43f3d5&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d43f3d5"]])

export default __exports__